import { z } from "zod"
import { Errors } from "../errors"

export const DEFAULT_API_TOKEN_NAME = "Default"

export const ApiTokenAccessEnum = {
  Full: "Full",
  Read: "Read",
} as const

export type ApiTokenAccess = (typeof ApiTokenAccessEnum)[keyof typeof ApiTokenAccessEnum]

export const CreateApiTokenSchema = z.object({
  name: z.string().trim().min(1, { error: Errors.FIELD_REQUIRED }).default(DEFAULT_API_TOKEN_NAME),
  access: z.enum(ApiTokenAccessEnum).default(ApiTokenAccessEnum.Full),
})

export const DeleteApiTokenSchema = z.object({
  id: z.string(),
})
